import { IPickupPoint } from "../../api/estore/checkout/interfaces/delivery-pickuppoint-interface.js";
import { BaseRedomElement } from "../../utils/base-redom-element.js";
import { ICmsDeliverySelectorConfiguration } from "./interfaces/cms-delivery-selector-config-interface.js";
import { DeliverySelectorStateManager } from "./delivery-selector-state-manager.js";
import { el } from "../../lib/redom.es.min.js";

export class DeliveryPickupPoint extends BaseRedomElement {
    config: ICmsDeliverySelectorConfiguration;
    stateManager: DeliverySelectorStateManager;
    pickupPoint: IPickupPoint;
    root: Node;

    constructor(config: ICmsDeliverySelectorConfiguration, stateManager: DeliverySelectorStateManager, pickupPoint: IPickupPoint) {
        super(config.useShadowRoot);
        this.config = config;
        this.root = this.config.useShadowRoot ? this.shadowRoot : this;
        this.stateManager = stateManager;
        this.pickupPoint = pickupPoint;
    }

    connectedCallback() {
        this.render();
        this.setValues();
    }
    
    render() {
        const rel = this.element.bind(this);
        
        const els = [
            this.config.useShadowRoot ? el("link", { rel: "stylesheet", href: this.config.cssFiles.pickupPointItem}) : null,
            el("a", 
                rel("name", "h6"),
                rel("address", "span.address"))
        ];

        this.mountArray(this.root, els);
    }

    update(pickupPoint: IPickupPoint) {
        this.pickupPoint = pickupPoint;
        this.setValues();
    }

    setValues() {
        const e = this.elements;
        const pp = this.pickupPoint;

        // Update element values
        const address = `${pp.address}, ${pp.postalCode} ${pp.postalArea}`;
        e.name.innerText = pp.name;
        e.address.innerText = address;

        // Set attributes
        this.setAttribute("data-id", pp.id);

        // Set classes
        if (pp.selected) {
            this.classList.add("selected");
        } else {
            this.classList.remove("selected");
        }
    }
}

customElements.define("delivery-pickuppoint", DeliveryPickupPoint);